// predictive-search-native.js
(function () {
  console.log('[PredictiveSearch] native script loaded');

  // --- STUB PARA DESATIVAR ALGOLIA DO TEMA (theme.js) ---
  // Se SearchProviderFactory não existir ou não tiver createProvider(),
  // criamos um stub inofensivo.
  if (
    !window.SearchProviderFactory ||
    typeof window.SearchProviderFactory.createProvider !== 'function'
  ) {
    window.SearchProviderFactory = {
      createProvider: function () {
        return {
          search: function () {
            // Promise resolvida para não rebentar nada
            return Promise.resolve();
          }
        };
      }
    };
  }

  function initPredictiveSearch(el) {
    var sectionInstanceId = el.getAttribute('section-id');
    if (!sectionInstanceId) {
      console.warn('[PredictiveSearch] Missing section-id attribute');
      return;
    }

    var form = el.closest('form');
    if (!form) {
      console.warn('[PredictiveSearch] No parent form found');
      return;
    }

    var input = form.querySelector('input[type="search"][name="q"]');
    if (!input) {
      console.warn('[PredictiveSearch] No search input found');
      return;
    }

    var results = el.querySelector('[slot="results"]');
    var loading = el.querySelector('[slot="loading"]');

    var noResultsText = el.dataset.noResultsText || 'No results found';
    var productsLabel = el.dataset.productsLabel || 'Products';

    el._initialResultsHTML =
      el._initialResultsHTML || (results ? results.innerHTML : '');
    el._abortController = null;

    function setLoading(active) {
      if (!loading) return;
      if (active) loading.classList.remove('hidden');
      else loading.classList.add('hidden');
    }

    function clearResults() {
      if (!results) return;
      results.innerHTML = '';
      // volta ao estado idle (popular searches)
      el.removeAttribute('data-has-results');
    }

    function handleInput(event) {
      var term = event.target.value.trim();
      console.log('[PredictiveSearch] term:', term);

      if (!term.length) {
        clearResults();
        setLoading(false);
        return;
      }

      getResults(term);
    }

    function getResults(term) {
      if (el._abortController) {
        el._abortController.abort();
      }

      el._abortController = new AbortController();

      var params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,collection,article,page,query',
        'resources[limit]': '10'
      });

      var base =
        (window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.search_url) ||
        '/search';

      var url = base + '/suggest.json?' + params.toString();
      console.log('[PredictiveSearch] fetch:', url);

      setLoading(true);

      fetch(url, {
        signal: el._abortController.signal,
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          console.log('[PredictiveSearch] status:', response.status);
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(function (data) {
          console.log('[PredictiveSearch] data:', data);

          if (!data || !data.resources) {
            console.warn('[PredictiveSearch] No resources in response');
            return;
          }

          // formato atual: data.resources.results.products
          // fallback para formatos antigos: data.resources.products
          var resources = data.resources;
          var resultsData = resources.results || resources;
          var products = resultsData.products || [];

          if (!results) return;

          if (!products.length) {
            el.setAttribute('data-has-results', 'true');
            results.innerHTML =
              '<div class="empty-state"><p class="h6">' +
              noResultsText +
              '</p></div>';
            return;
          }

          // construir HTML simples de lista
          var html = '';
          html += '<div class="v-stack gap-4 sm:gap-6">';
          html += '<p class="h5">' + productsLabel + '</p>';
          html += '<div class="v-stack gap-4 sm:gap-6">';

          products.forEach(function (product) {
            var title = product.title || '';
            var url = product.url || '#';
            var thumbnail = product.image || '';

            html +=
              '<a href="' +
              url +
              '" class="predictive-search-result group" data-instant>';
            if (thumbnail) {
              html +=
                '<img src="' +
                thumbnail +
                '" alt="' +
                title.replace(/"/g, '&quot;') +
                '" loading="lazy" width="96" height="96">';
            }
            html += '<div class="v-stack gap-1">';
            html += '<p class="text-body">' + title + '</p>';
            html += '</div>';
            html += '</a>';
          });

          html += '</div></div>';

          el.setAttribute('data-has-results', 'true');
          results.innerHTML = html;
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          console.error('[PredictiveSearch] Error:', error);
        })
        .finally(function () {
          setLoading(false);
        });
    }

    // remover listener antigo se existir
    if (el._inputHandler) {
      input.removeEventListener('input', el._inputHandler);
    }

    el._inputHandler = handleInput;
    input.addEventListener('input', handleInput);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var instances = document.querySelectorAll(
      'predictive-search[section-id]'
    );
    console.log(
      '[PredictiveSearch] DOMContentLoaded, instances:',
      instances.length
    );
    instances.forEach(initPredictiveSearch);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var instances = event.target.querySelectorAll(
      'predictive-search[section-id]'
    );
    console.log(
      '[PredictiveSearch] section load, instances:',
      instances.length
    );
    instances.forEach(initPredictiveSearch);
  });
})();
